import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ValidationPanParams } from 'src/app/models/mandatos-express/validation-trx-params';
import { ValidationPanResponse } from 'src/app/models/mandatos-express/validation-trx-response';
import { ConsultaBinParams } from 'src/app/models/mandatos-express/consulta-bin-params';
import { ConsultaIdServicioParams } from 'src/app/models/mandatos-express/consulta-idservicio-params';
import { ConsultaBinResponse } from 'src/app/models/mandatos-express/consulta-bin-response';
import { ConsultaIdServicioResponse } from 'src/app/models/mandatos-express/consulta-idservicio-response';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Origin': '*'
  })
};

@Injectable({
  providedIn: 'root'
})
export class CardinalCommerceService {
  urlValTarjeta = this.environment.urlAmbiente + '/apiTransaccionMT/validartarjeta';
  urlValTarjetaExpress = this.environment.urlAmbiente + '/apiTransaccionMT/validartarjetaExpress';
  urlValTarjetaSusComercio = this.environment.urlAmbiente + '/apiTransaccionMT/validartarjetaSusComercio';
  urlConsultaBin = this.environment.urlAmbiente + '/apiTransaccionMT/consultaBin';
  urlConsultaBinExpress = this.environment.urlAmbiente + '/apiTransaccionMT/consultaBinExpress';
  urlConsultaBinSusComercio = this.environment.urlAmbiente + '/apiTransaccionMT/consultaBinSusComercio';

  constructor(private http: HttpClient, @Inject('env') private environment: any) { }

  // validacionPan(validatePanParams: ValidationPanParams) {
  //   return this.http.post<ValidationPanResponse>(
  //     this.environment.urlAmbiente + '/apiTransaccionMT/validartarjeta', validatePanParams, httpOptions);
  // }
  validacionPan(validatePanParams: ValidationPanParams, isEmbebido: boolean) {
    let url = isEmbebido ? this.urlValTarjeta : this.urlValTarjetaExpress;
    return this.http.post<ValidationPanResponse>(url, validatePanParams, httpOptions);
  }
  validacionPanSusComercio(validatePanParams: ValidationPanParams, isEmbebido: boolean) {
    let url = isEmbebido ? this.urlValTarjeta : this.urlValTarjetaSusComercio;
    return this.http.post<ValidationPanResponse>(url, validatePanParams, httpOptions);
  }

  consultaBin(params: ConsultaBinParams, isEmbebido: boolean){
    let url = isEmbebido ? this.urlConsultaBin : this.urlConsultaBinExpress;
    return this.http.post<ConsultaBinResponse>(url, params, httpOptions);
  }
  consultaBinSusComercio(params: ConsultaBinParams, isEmbebido: boolean){
    let url = isEmbebido ? this.urlConsultaBin : this.urlConsultaBinSusComercio;
    return this.http.post<ConsultaBinResponse>(url, params, httpOptions);
  }

  consultaIdServicio(params: ConsultaIdServicioParams){
    return this.http.post<ConsultaIdServicioResponse>(this.environment.urlAmbiente + '/apiMandatosMT/consultaIdServicio', params, httpOptions);
  }

}
